import axios from '@/libs/axios'

class PersonasService {
  /**
   * Obtener todas las personas
   * @returns {Promise<Array>} - Lista de personas
   */
  async getAll() {
    try {
      const response = await axios.get('/personas')
      return response.data
    } catch (error) {
      console.error('Error al obtener personas:', error)
      throw error
    }
  }

  /**
   * Obtener una persona por ID
   * @param {number} id - ID de la persona
   * @returns {Promise<Object>} - Datos de la persona
   */
  async getById(id) {
    try {
      const response = await axios.get(`/personas/${id}`)
      return response.data
    } catch (error) {
      console.error('Error al obtener persona:', error)
      throw error
    }
  }

  /**
   * Crear una nueva persona
   * @param {Object} personaData - Datos de la persona
   * @returns {Promise<Object>} - Persona creada
   */
  async create(personaData) {
    try {
      const response = await axios.post('/personas', personaData)
      return response.data
    } catch (error) {
      console.error('Error al crear persona:', error)
      throw error
    }
  }

  /**
   * Actualizar una persona
   * @param {number} id - ID de la persona
   * @param {Object} personaData - Datos actualizados
   * @returns {Promise<Object>} - Persona actualizada
   */
  async update(id, personaData) {
    try {
      const response = await axios.put(`/personas/${id}`, personaData)
      return response.data
    } catch (error) {
      console.error('Error al actualizar persona:', error)
      throw error
    }
  }

  /**
   * Eliminar una persona
   * @param {number} id - ID de la persona
   * @returns {Promise<void>}
   */
  async delete(id) {
    try {
      await axios.delete(`/personas/${id}`)
    } catch (error) {
      console.error('Error al eliminar persona:', error)
      throw error
    }
  }
}

export default new PersonasService()
